import React from 'react';
import PropTypes from 'prop-types';

import { Breadcrumbs } from 'js/components/Breadcrumbs/Breadcrumbs';

import clsx from 'clsx';

import gridStyles from 'assets/style/grid.module.css';
import styles from './styles.module.css';

const getBreadcrumbs = (primaryTreatment, i18n) => {
  const treatmentType = primaryTreatment.treatmentCategoryGroup || {};
  const params = [
    {
      name: i18n('page.treatment-guide.title'),
      pageType: 'treatmentGuide',
    },
  ];

  if (treatmentType.infoPageEnabled) {
    params.push({
      name: treatmentType.name,
      pageType: 'treatmentType',
      uriParams: {
        treatmentTypeId: treatmentType.id,
      },
    });
  }

  if (primaryTreatment.infoPageEnabled) {
    params.push({
      name: primaryTreatment.name,
      pageType: 'treatment',
      uriParams: {
        treatmentId: primaryTreatment.id,
        normalisedName: primaryTreatment.normalisedName,
      },
    });
  }

  params.push({
    name: i18n('page.question.questions-and-answers'),
  });

  return <Breadcrumbs breadcrumbsParams={params} showIcon />;
};

const getTreatmentLinks = (enabledTreatments, generateUri) => {
  const links = enabledTreatments.map((category) => (
    <a
      href={generateUri('treatment', {
        normalisedName: category.normalisedName,
        treatmentId: category.id,
      })}
      key={category.id}
      className={styles.treatmentLink}
    >
      {category.name}
    </a>
  ));

  return links.reduce((res, link) => res.concat([link, ', ']), []).slice(0, -1);
};

const Question = ({ question, i18n, generateUri }) => {
  const enabledTreatments = question.treatmentCategories.filter(
    (treatment) => treatment.infoPageEnabled
  );
  const primaryTreatment = question.treatmentCategories[0];
  const breadcrumbs = getBreadcrumbs(primaryTreatment, i18n);
  const treatments = getTreatmentLinks(enabledTreatments, generateUri);
  const treatmentComponent = treatments.length ? (
    <div
      className={clsx(
        gridStyles['col-md-8'],
        gridStyles['col-sm-6'],
        gridStyles['col-xs-12']
      )}
    >
      <h2 className={styles.treatmentLinks}>
        <span className={styles.treatmentLinksLabel}>
          {i18n('page.question.treatment-links-label')}:&nbsp;
        </span>
        {treatments}
      </h2>
    </div>
  ) : null;

  return (
    <div className={clsx(styles.wrapper, gridStyles.row)}>
      <div className={clsx(gridStyles['col-xs-12'], styles.heroContent)}>
        <div className={clsx(styles.wrapper, gridStyles.row)}>
          <div className={clsx(gridStyles['col-xs-12'])}>{breadcrumbs}</div>
          <div className={clsx(gridStyles['col-xs-12'])}>
            <h1 className={styles.title}>{question.title}</h1>
          </div>
          {treatmentComponent}
        </div>
      </div>
    </div>
  );
};

Question.propTypes = {
  question: PropTypes.object,
  i18n: PropTypes.func,
  generateUri: PropTypes.func,
};

export default Question;
